import {pb} from './pocketbase';
import eventEmitter from './event.service';

export const getNotifications = async () => {
    try {
        const result = await pb.collection('notifications').getList(1, 50, {
            sort: '-created',
        });
        return result.items;
    } catch (error) {
        console.error('Erreur lors de la récupération des notifications:', error);
        return [];
    }
};

export const getLatestNotifications = async (limit = 5) => {
    try {
        const result = await pb.collection('notifications').getList(1, limit, {
            sort: '-created',
        });
        return result.items;
    } catch (error) {
        console.error(`Erreur lors de la récupération des ${limit} dernières notifications:`, error);
        return [];
    }
};


export const createNotification = async (notificationData) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const notificationWithPartnerId = {
                ...notificationData,
                partner_id: pb.authStore.record.partner_id
            };
            const record = await pb.collection('notifications').create(notificationWithPartnerId);
            
            // Si la notification est pour l'utilisateur connecté, incrémenter le compteur
            if (notificationData.recipient_id === pb.authStore.record.id) {
                incrementUnreadNotificationsCount();
            }
            
            eventEmitter.dispatch('notificationsUpdated');
            return record;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer la notification sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error('Erreur lors de la création de la notification:', error);
        return null;
    }
};

export const updateNotification = async (id, dataNotification) => {
    try {
        const record = await pb.collection('notifications').update(id, dataNotification);
        return record;
    } catch (error) {
        console.error('Erreur lors de la mise à jour de la notification:', error);
        throw error;
    }
};

export const deleteNotification = async (id) => {
    try {
        await pb.collection('notifications').delete(id);
        return true;
    } catch (error) {
        console.error('Erreur lors de la suppression de la notification:', error);
        return false;
    }
};

export const markNotificationAsRead = async (id) => {
    try {
        await pb.collection('notifications').update(id, { read: true });
        
        // Décrémenter le compteur pour l'utilisateur connecté
        decrementUnreadNotificationsCount();
        
        eventEmitter.dispatch('notificationsUpdated');
    } catch (error) {
        console.error('Erreur lors de la mise à jour de la notification:', error);
    }
};

export const hasUnreadNotifications = async () => {
    try {
        const result = await pb.collection('notifications').getList(1, 1, {
            filter: 'read = false',
        });
        return result.totalItems > 0;
    } catch (error) {
        return false;
    }
};

export const deleteMultipleNotifications = async (notificationIds) => {
    try {
        // Utiliser Promise.all pour exécuter toutes les suppressions en parallèle
        await Promise.all(
            notificationIds.map(id => pb.collection('notifications').delete(id))
        );
        eventEmitter.dispatch('notificationsUpdated');
        return true;
    } catch (error) {
        console.error('Erreur lors de la suppression multiple des notifications:', error);
        throw error;
    }
};

export const markAllNotificationsAsRead = async () => {
    try {
        // Récupérer toutes les notifications non lues
        const result = await pb.collection('notifications').getList(1, 100, {
            filter: 'read = false',
        });
        
        // Marquer chaque notification comme lue
        await Promise.all(
            result.items.map(notification => 
                pb.collection('notifications').update(notification.id, { read: true })
            )
        );
        
        eventEmitter.dispatch('notificationsUpdated');
        return true;
    } catch (error) {
        console.error('Erreur lors du marquage de toutes les notifications comme lues:', error);
        throw error;
    }
};

export const markMultipleNotificationsAsRead = async (notificationIds) => {
    try {
        // Marquer les notifications spécifiées comme lues
        await Promise.all(
            notificationIds.map(id => 
                pb.collection('notifications').update(id, { read: true })
            )
        );
        
        // Décrémenter le compteur pour chaque notification marquée comme lue
        for (let i = 0; i < notificationIds.length; i++) {
            decrementUnreadNotificationsCount();
        }
        
        eventEmitter.dispatch('notificationsUpdated');
        return true;
    } catch (error) {
        console.error('Erreur lors du marquage des notifications sélectionnées comme lues:', error);
        throw error;
    }
};

// Compteur local des notifications non lues
let unreadNotificationsCounter = 0;

// Initialiser le compteur au démarrage
export const initializeUnreadNotificationsCount = async () => {
    try {
        if (!pb.authStore.isValid || !pb.authStore.model) {
            unreadNotificationsCounter = 0;
            return 0;
        }
        
        const result = await pb.collection('notifications').getList(1, 1, {
            filter: 'read = false',
        });
        unreadNotificationsCounter = result.totalItems;
        return unreadNotificationsCounter;
    } catch (error) {
        unreadNotificationsCounter = 0;
        return 0;
    }
};

// Obtenir le compteur actuel (synchrone)
export const getUnreadNotificationsCount = () => {
    return unreadNotificationsCounter;
};

// Incrémenter le compteur
export const incrementUnreadNotificationsCount = () => {
    unreadNotificationsCounter++;
    eventEmitter.dispatch('notificationCounterUpdated', unreadNotificationsCounter);
};

// Décrémenter le compteur
export const decrementUnreadNotificationsCount = () => {
    if (unreadNotificationsCounter > 0) {
        unreadNotificationsCounter--;
    }
    eventEmitter.dispatch('notificationCounterUpdated', unreadNotificationsCounter);
};
